import api from "./index";

export const login = (credentials) => {
  return api.postRequest("/1.0/login", credentials);
};

export const logout = () => {
  return api.delRequest("/logout");
};

export const getUserProfile = () => {
  return api.getRequest("/1.0/profile");
};

export const resetPassword = (params) => {
  return api.postRequest("/1.0/reset-pw", params);
};

export const changePassword = (data) => {
  return api.postRequest("/1.0/set-pw", data);
};
